import { EmailLinkTarget } from './email-app.interfaces';
import { Label } from './email-app.store';

const iconMap: Record<string, string> = {
  inbox: 'assets/icons/inbox.svg',
  sent: 'assets/icons/sent.svg',
  sentitems: 'assets/icons/sent.svg',
  draft: 'assets/icons/pencil-line.svg',
  drafts: 'assets/icons/pencil-line.svg',
  junkemail: 'assets/icons/spam.svg',
  spam: 'assets/icons/spam.svg',
  important: 'assets/icons/important.svg',
  trash: 'assets/icons/trash.svg',
  deleteditems: 'assets/icons/trash.svg',
  all: 'assets/icons/all.svg',
  unread: 'assets/icons/unread.svg',
  read: 'assets/icons/read.svg',
  starred: 'assets/icons/starred.svg',
  archive: 'assets/icons/archive.svg',
  conversationhistory: 'assets/icons/folder.svg',
  outbox: 'assets/icons/box-arrow-up.svg',
  chat: 'assets/icons/chat.svg',
  fundings: 'assets/icons/briefcase.svg',
  funding: 'assets/icons/briefcase.svg',
  contracts: 'assets/icons/file-text.svg',
  contract: 'assets/icons/file-text.svg',
};

export const getLabelIcon = (label: Label): string => {
  const key = label.name.toLowerCase().replace(/\s+/g, '');
  return iconMap[key] || 'assets/icons/folder.svg';
};

/**
 * Linking is done at thread level. Providers that do not expose a thread id fall
 * back to the message itself, which must be sent as `emailId` — not as a thread id.
 */
export const emailLinkTarget = (email: { ID: string; ThreadID?: string }): EmailLinkTarget =>
  email?.ThreadID ? { threadId: email.ThreadID } : { emailId: email?.ID };

/**
 * Key used to cache associations, matching the id sent to the backend.
 */
export const emailLinkKey = (target: EmailLinkTarget): string =>
  target.threadId || target.emailId || '';

export const FAVORITE_LABELS = ['favorite', 'STARRED'];

export const SENT_LABELS = ['sent', 'sentitems'];

export const ARCHIVE_LABELS = ['archive'];

export const INBOX_LABELS = ['inbox'];
